import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfWorkingSessionsEntityMapper } from '../../../infrastructure/mappers/working-sessions/self-working-sessions.entity.mapper';
import { GetSelfWorkingSessionsRequestDto } from '../../dtos/working-sessions/get-self-working-sessions.request.dto';
import { GetSelfWorkingSessionsResponseDto } from '../../dtos/working-sessions/get-self-working-sessions.response.dto';
import { GetSelfWorkingSessionsQuery } from '../../queries/working-sessions/get-self-working-sessions.query';

export class GetSelfWorkingSessionsController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfWorkingSessionsQuery,
    protected readonly mapper: SelfWorkingSessionsEntityMapper
  ) {}

  async get(
    props: GetSelfWorkingSessionsRequestDto
  ): Promise<GetSelfWorkingSessionsResponseDto[]> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetSelfWorkingSessionsController.get encountered an error ${error}`
      );
    }
  }
}
